import type { ReactNode } from 'react';

import { ConfirmDialog } from '@/components/atoms/dialog';
import { StartRecordingNote } from '@/components/molecules/voice-recording/StartRecordingNote';
import { useTranslation } from '@/i18n';

interface RecordingStartConfirmDialogProps {
  readonly visible: boolean;
  readonly consentDialog: ReactNode;
  readonly onConfirm: () => void | Promise<void>;
  readonly onDismiss: () => void;
}

export const RecordingStartConfirmDialog = ({
  visible,
  consentDialog,
  onConfirm,
  onDismiss,
}: RecordingStartConfirmDialogProps) => {
  const { t } = useTranslation();

  return (
    <>
      {consentDialog}
      <ConfirmDialog
        visible={visible}
        title={t('recording.startConfirmation.title')}
        body={t('recording.startConfirmation.body')}
        note={<StartRecordingNote />}
        confirmLabel={t('recording.startConfirmation.confirm')}
        dismissLabel={t('recording.startConfirmation.dismiss')}
        onConfirm={onConfirm}
        onDismiss={onDismiss}
      />
    </>
  );
};
